var _CloseSmall;
import { Controller, useForm } from "react-hook-form";
import { useAmplitude } from "@crehana/analytics";
import { useTranslation } from "@crehana/i18n";
import { CloseSmall } from "@crehana/icons/outline";
import { PrimaryButton, Row, TextField, TextLink } from "@crehana/ui";
import { getImgixUrl } from "@crehana/utils";
import PhoneInput from "../PhoneInput";
import { CALL_CENTER_DIALOG_PAGE_KEY } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CallCenterForm = function CallCenterForm(_ref) {
  var _errors$name;
  var onSubmit = _ref.onSubmit,
    closeDialog = _ref.closeDialog,
    dialogSource = _ref.dialogSource,
    popupData = _ref.popupData;
  var _useAmplitude = useAmplitude(),
    logEvent = _useAmplitude.logEvent;
  var _useForm = useForm({
      mode: 'onChange'
    }),
    handleSubmit = _useForm.handleSubmit,
    register = _useForm.register,
    errors = _useForm.errors,
    formState = _useForm.formState,
    control = _useForm.control;
  var _useTranslation = useTranslation(CALL_CENTER_DIALOG_PAGE_KEY),
    t = _useTranslation.t,
    countryCode = _useTranslation.countryCode;
  var mobileImage = getImgixUrl((popupData === null || popupData === void 0 ? void 0 : popupData.imageResponsive) || 'https://crehana-public-catalog.imgix.net/images/app/gallery/2022/06/08/4c70b382/3d6a6568.jpg', {
    auto: 'format',
    h: 128,
    fit: 'fillmax'
  });
  var tabletImage = getImgixUrl((popupData === null || popupData === void 0 ? void 0 : popupData.imageTablets) || 'https://crehana-public-catalog.imgix.net/images/app/gallery/2022/06/08/4c70b382/3d6a6568.jpg', {
    auto: 'format',
    h: 122,
    fit: 'fillmax'
  });
  var desktopImage = getImgixUrl((popupData === null || popupData === void 0 ? void 0 : popupData.image) || 'https://crehana-public-catalog.imgix.net/images/app/gallery/2022/06/08/00057bf5/026fe2e4.jpg', {
    auto: 'format',
    h: 642,
    fit: 'fillmax'
  });
  var closeAndTrackDialog = function closeAndTrackDialog() {
    logEvent({
      event: 'Close Call Center Dialog',
      data: {
        dialogSource: dialogSource
      }
    });
    closeDialog();
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "relative bg-base-dark",
    children: [/*#__PURE__*/_jsxs(Row, {
      className: "my-0 lg:items-center lg:flex-row-reverse",
      children: [/*#__PURE__*/_jsx("div", {
        className: "w-full pt-0 pb-0 lg:w-5/12 lg:pt-0 lg:pb-0",
        children: /*#__PURE__*/_jsxs("picture", {
          children: [/*#__PURE__*/_jsx("source", {
            srcSet: mobileImage,
            media: "(max-width: 767px)",
            height: "128px",
            type: "image/jpg"
          }), /*#__PURE__*/_jsx("source", {
            srcSet: tabletImage,
            media: "(min-width: 768px) and (max-width: 1365px)",
            height: "122px",
            type: "image/jpg"
          }), /*#__PURE__*/_jsx("source", {
            srcSet: desktopImage,
            media: "(min-width: 1366px)",
            height: "642px",
            type: "image/jpg"
          }), /*#__PURE__*/_jsx("img", {
            className: "block object-cover w-full rounded-tr-5 rounded-br-5",
            src: desktopImage,
            alt: "teacher",
            decoding: "async",
            loading: "lazy"
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "w-full pt-0 pb-0 lg:w-7/12 lg:pt-0 lg:pb-0",
        children: /*#__PURE__*/_jsxs("div", {
          className: "justify-center px-24 pt-32 pb-48 mx-auto lg:pt-64 sm:px-56 sm:py-32 sm:h-auto",
          style: {
            maxWidth: 500
          },
          children: [/*#__PURE__*/_jsx("p", {
            className: "mb-16 text-center text-white font-h2",
            children: popupData.title || t('DEFAULT_TITLE')
          }), /*#__PURE__*/_jsx("p", {
            className: "mb-24 text-center text-white font-body3",
            children: popupData.description || t('DEFAULT_DESCRIPTION')
          }), /*#__PURE__*/_jsx("div", {
            className: "mb-24 sm:mb-32",
            children: /*#__PURE__*/_jsxs("div", {
              className: "w-full mb-24",
              children: [/*#__PURE__*/_jsx(TextField, {
                className: "block w-full mb-16",
                wrapperClassName: "bg-white",
                maxLength: 50,
                darkMode: true,
                name: "name",
                label: t('CALL_CENTER_DIALOG_NAME'),
                ref: register({
                  required: {
                    value: true,
                    message: t('REQUIRED_FIELD')
                  },
                  maxLength: {
                    value: 50,
                    message: t('MAX_CHARS')
                  }
                }),
                errorText: (_errors$name = errors.name) === null || _errors$name === void 0 ? void 0 : _errors$name.message
              }), /*#__PURE__*/_jsx(Controller, {
                control: control,
                name: "phoneNumber",
                rules: {
                  required: {
                    value: true,
                    message: t('REQUIRED_FIELD')
                  },
                  validate: function validate(data) {
                    return data.phoneNumber && data.isValid;
                  }
                },
                render: function render(_ref2) {
                  var onChange = _ref2.onChange;
                  return /*#__PURE__*/_jsx(PhoneInput, {
                    className: "mb-24",
                    showAll: true,
                    isDarkMode: true,
                    onChange: onChange,
                    isRequired: false,
                    label: t('PHONE_NUMBER'),
                    defaultCountry: countryCode
                  });
                }
              })]
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex flex-col items-center",
            children: [/*#__PURE__*/_jsx(PrimaryButton, {
              darkMode: true,
              className: "px-64 lg:px-80",
              size: "l",
              label: (popupData === null || popupData === void 0 ? void 0 : popupData.callToAction) || t('DEFAULT_CTA_LABEL'),
              onClick: handleSubmit(onSubmit),
              disabled: !formState.isValid
            }), /*#__PURE__*/_jsx(TextLink, {
              className: "mt-24 lg:hidden",
              label: "Cerrar",
              onClick: closeAndTrackDialog
            })]
          })]
        })
      })]
    }), /*#__PURE__*/_jsx("button", {
      type: "button",
      className: "absolute top-0 right-0 items-center justify-center hidden p-4 mt-16 mr-16 rounded-full cursor-pointer lg:block",
      style: {
        backgroundColor: 'rgba(7, 14, 39, 0.5)'
      },
      onClick: closeAndTrackDialog,
      children: _CloseSmall || (_CloseSmall = /*#__PURE__*/_jsx(CloseSmall, {
        size: 32,
        color: "white"
      }))
    })]
  });
};
export default CallCenterForm;